<template>
  <div class="konami-component">
    <form
      class="form d-flex align-items-end justify-content-center justify-content-lg-start"
      @submit.prevent="submit"
    >
      <div class="form-group">
        <label for="konamiCode" class="-small">
          {{ $t('VIP CODE') }}
        </label>
        <input
          type="text"
          id="konamiCode"
          name="konamiCode"
          :placeholder="$t('Enter your exclusive access code')"
          v-model="konamiCode"
          required
        />
      </div>
      <button class="btn form-button" type="submit" aria-label="$t('Submit')">
        <i class="icon-next"></i>
      </button>
    </form>
    <NoSSR>
      <div
        class="countdown"
        v-if="isInProductPage && countdown && countdown > 0"
      >
        <div class="wrapper" key="count">
          <p class="countdown-title" v-text="$t('Coming soon')"></p>
          <Countdown
            v-if="countdown && countdown > 0"
            :time="countdown"
            tag="div"
            class="d-flex align-items-center justify-content-center justify-content-lg-start"
            :transform="transform"
            @end="onCountdownEnd"
          >
            <template slot-scope="props">
              <div class="countdown-digit">
                <span class="countdown-digit-number">
                  {{ props.days }}
                </span>
                <span class="countdown-digit-label">
                  {{ $t('days') }}
                </span>
              </div>
              <div class="countdown-digit">
                <span class="countdown-digit-number">
                  {{ props.hours }}
                </span>
                <span class="countdown-digit-label">
                  {{ $t('hrs') }}
                </span>
              </div>
              <div class="countdown-digit">
                <span class="countdown-digit-number">
                  {{ props.minutes }}
                </span>
                <span class="countdown-digit-label">
                  {{ $t('min') }}
                </span>
              </div>
              <div class="countdown-digit">
                <span class="countdown-digit-number">
                  {{ props.seconds }}
                </span>
                <span class="countdown-digit-label">
                  {{ $t('sec') }}
                </span>
              </div>
            </template>
          </Countdown>
        </div>
      </div>
    </NoSSR>
  </div>
</template>

<script>
import { ReadyHook } from 'vue-asyncready'
import { mapActions } from 'vuex'
import NoSSR from 'src/themes/zenith/node_modules/vue-no-ssr'
import Countdown from '@chenfengyuan/vue-countdown'

export default {
  props: ['konami', 'code', 'countdown', 'isInProductPage'],
  name: 'ProductHeaderKonami',
  mixins: [ReadyHook],
  components: {
    Countdown,
    NoSSR
  },
  methods: {
    ...mapActions('konami', ['setOverlay']),
    transform(props) {
      Object.entries(props).forEach(([key, value]) => {
        const digits = value < 10 ? `0${value}` : value
        props[key] = `${digits}`
      })
      return props
    },
    onCountdownEnd() {
      this.$bus.$emit('setCountdown', false)
    },
    submit() {
      const isEqual = this.konami.codes.includes(this.konamiCode.toLowerCase())
      if (isEqual) {
        this.setOverlay({ overlay: false })
        this.$bus.$emit('setCountdown', -1)
      }
    }
  },
  data() {
    return {
      konamiCode: null
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';

.konami-component {
  margin-top: 5rem;

  /deep/ .form-group {
    input {
      padding: 1rem 5rem 1rem 0;
    }

    label {
      margin-bottom: 1rem;
      font-weight: 500;

      @include bp(max md) {
        text-align: center;
      }
    }
  }

  .form-button {
    padding: 0;
    aspect-ratio: 1;
    border-radius: 0.3125rem;
    margin-left: 1.25rem;
  }

  .countdown {
    line-height: 1.2;
    margin-top: 4rem;

    @include bp(max md) {
      margin-bottom: 7rem
    }

    &-title {
      text-transform: uppercase;

      @include bp(max md) {
        text-align: center;
      }
    }

    &-digit {
      position: relative;
      min-width: 7rem;
      text-transform: uppercase;
      font-size: 1rem;
      font-weight: 300;
      display: flex;
      flex-direction: column;
      align-items: start;

      &-number {
        display: block;
        font-size: 5rem;
      }

      &:not(:last-child) .countdown-digit-number {
        display: flex;
        align-items: center;

        &:after {
          content: '';
          width: 0.25rem;
          height: 0.25rem;
          border-radius: 0.0625rem;
          background-color: var(--zenith-theme-primary);
          transform: rotate(45deg);
          margin-inline: 1rem;
        }
      }
    }
  }
}
</style>
